import { Component, EventEmitter, Input, OnInit, Output, ViewChild, HostListener } from '@angular/core';
import { PermissionsService } from '../../services/permissions/permissions.service';
import { OrganisationService } from '../../services/organisation/organisation.service';

@Component({
  selector: 'app-dept-category-picker',
  templateUrl: './dept-category-picker.component.pug',
  styleUrls: ['./dept-category-picker.component.scss'],
  standalone: false
})
export class DeptCategoryPickerComponent implements OnInit {
  @ViewChild('departmentCategoryFilter', { static: false }) departmentCategoryFilter: any
  @ViewChild('departmentFilter', { static: false }) departmentFilter: any
  @Input() departmentCategoryId = 'all';
  @Input() departmentId: any = 'all';
  @Output() department_data = new EventEmitter();
  categoryAddedOptions: any[] = [{ 'category_id': 'all', 'category_name': $localize`All` }];
  departmentAddedOptions: any[] = [{ 'department_id': 'all', 'department_name': $localize`All` }, { 'department_id': 'no_department', 'department_name': $localize`No department` }];
  filterDeptCategoryByVar;
  filterDepartmentByVar;
  categoryOptions: any[] = [];
  categoryList: any[] = [];
  departmentOptions: any[] = [];
  departments = [];
  departmentList: any[] = [];
  filterByLabel = '';

@HostListener('document:click', ['$event'])
clickout(event: any): void {
  const isInsideElement = (id: string): boolean =>
  event.target.id === id || (event.path && event.path[1].id === id);

  const insideDeptCategoryDropDownClick = isInsideElement('deptCategoryDropDown');
  if (!insideDeptCategoryDropDownClick) {
    this.departmentCategoryFilter.hide();
  }

  const insideDeptDropDownClick = isInsideElement('deptDropDown');
  if (!insideDeptDropDownClick) {
    this.departmentFilter.hide();
  }
}

  constructor(private permissions: PermissionsService,
    private organisationService: OrganisationService
  ) { }

  ngOnInit(): void {
    this.organisationService.GetPrefectehedDepartment().subscribe((res) => {
      if(res){
        this.departments = res['data']['departments'];
        this.getCategoriesList(this.departments);
        this.getDepartmentsList(this.departments);
        if (this.departmentId && this.departmentId !== 'all') {
          const department = this.departmentOptions.find(department => department.department_id == this.departmentId);
          this.filterDepartmentByVar = department['department_name'];
        } else{
          this.filterDepartmentByVar = $localize`All`;
        }
        if (this.departmentCategoryId && this.departmentCategoryId !== 'all') {
          const department = this.categoryOptions.find(department => department.category_id == this.departmentCategoryId)
          this.filterDeptCategoryByVar = department['category_name'];
        } else{
          this.filterDeptCategoryByVar = $localize`All`;
        }
      }
    });
  }

  getCategoriesList(departments) { //returns unique category list from departments array
    this.categoryOptions = this.categoryAddedOptions;
    departments.forEach(department => {
      const valueExists = this.categoryOptions.find(option => option['category_id'] === department['category_id'])
      if (!valueExists) {
        this.categoryOptions.push({
          'category_id': department['category_id'],
          'category_name': department['category_name']
        })
      }
    })
    this.categoryList = this.categoryOptions;
  }

  getDepartmentsList(departments) {//returns unique department list from departments array
    this.departmentOptions = this.departmentAddedOptions;
    departments.forEach(department => {
      const valueExists = this.departmentOptions.find(option => option['department_id'] === department['id'])
      if (!valueExists) {
        this.departmentOptions.push({
          'department_id': department['id'],
          'department_name': department['department']
        })
      }
    })
    this.departmentList = this.departmentOptions;
  }

  filterDepartmentCategory(option) {
    this.departmentCategoryId = option['category_id'];
    this.filterDeptCategoryByVar = option['category_name'];
    this.categoryOptions = this.categoryList; //To keep the list as it is and not sorting each time

    if (this.departmentId == 'no_department') {
      this.departmentId = 'all';
    }

    if (option['category_id'] == 'all') {
      this.departmentOptions = this.departmentAddedOptions;
      this.filterDepartmentByVar = option['category_name'];
      this.departmentId = option['category_id'];
      this.departmentOptions = this.departmentList; //Display all departments when All is selected
    } else {
      const filteredDepartments = this.departments.filter(department => department['category_id'] == option['category_id'])
      this.departmentOptions = [];
      this.departmentOptions[0] = this.departmentAddedOptions[0];
      this.filterDepartmentByVar = $localize`All`
      this.departmentId = 'all';
      filteredDepartments.map(dept => {
        const valueExists = this.departmentOptions.find(option => option['department_id'] === dept['id'])
        if (!valueExists) {
          this.departmentOptions.push({
            'department_id': dept['id'],
            'department_name': dept['department']
          })
        }
      })
    }
    if (this.departmentCategoryFilter) {
      this.departmentCategoryFilter.hide();
    }
    this.department_data.emit({
      'department_id': this.departmentId,
      'department_category_id': this.departmentCategoryId
    })
  }

  filterDepartment(option) {
    this.departmentId = option['department_id'];
    this.filterDepartmentByVar = option['department_name'];

    if (this.departmentCategoryId == 'all' && option['department_id'] == 'all') {
      this.filterDeptCategoryByVar = option['department_name'];
      this.departmentOptions = this.departmentList;
    } else if (option['department_id'] == 'no_department') {
      this.filterDeptCategoryByVar = $localize`All`;
      this.departmentCategoryId = 'all';
      this.departmentOptions = this.departmentList;
    } else {
      const filteredDepartmentCategory = this.departments.filter(dept => dept['category_id'] == this.departmentCategoryId);
      filteredDepartmentCategory.map(dept => {
        const valueExists = this.departmentOptions.find(option => option['department_id'] === dept['id'])
        if (!valueExists) {
          this.departmentOptions.push({
            'department_id': dept['id'],
            'department_name': dept['department']
          })
        }
      })
      let filteredDeptCategory: any = this.departments.find(department => department['id'] == option['department_id']);
      this.categoryOptions = this.categoryList;
      if (filteredDeptCategory) {
        this.departmentCategoryId = filteredDeptCategory['category_id'];
        this.filterDeptCategoryByVar = filteredDeptCategory['category_name'];
      }
    }

    if (this.departmentFilter) {
      this.departmentFilter.hide();
    }
    this.department_data.emit({
      'department_id': this.departmentId,
      'department_category_id': this.departmentCategoryId
    })
  }

  reset() {
    this.departmentId = 'all';
    this.departmentCategoryId = 'all';
    this.filterDepartmentByVar = $localize`All`;
    this.filterDeptCategoryByVar = $localize`All`;
  }
}
